import { Flex, Text } from '@chakra-ui/react';
import { AppLink, LANDING_ROUTES } from '@cyberkongz/ui';

export function KollectionBreadcrumb({ label }: { label: string }) {
  return (
    <Flex
      css={{
        alignItems: 'center',
        color: 'textSecondary',
        textTransform: 'uppercase',
        fontSize: ['xs', 'sm'],
        letterSpacing: '0.05em',
      }}
    >
      <AppLink href={LANDING_ROUTES.KOLLECTIONS}>THE KOLLECTIONS</AppLink>
      <Text mx="2">/</Text>
      <Text>{label}</Text>
    </Flex>
  );
}
